export default {
  brand: "A&A MOTORS",
  tagline: "JEDE FAHRT. JEDER LIFESTYLE.",
  slogan: "ALLE AUTOS. ALLE STILE. EIN NAME.",
  nav: {
    fleet: "Flotte",
    noDeposit: "Ohne Kaution",
    how: "Ablauf",
    about: "Über uns",
    faq: "FAQ",
    contact: "Kontakt",
    book: "Auto buchen",
    menu: "Menü",
    close: "Schließen",
  },
  hero: {
    eyebrow: "Autovermietung Dubai",
    line1: "JEDE FAHRT.",
    line2: "JEDER LIFESTYLE.",
    sub: "Vom Alltagsfahrzeug bis zum außergewöhnlichen Erlebnis.",
    ctaFleet: "Flotte entdecken",
    ctaBook: "Auto buchen",
    scroll: "Scrollen",
  },
  categories: {
    all: "Alle Fahrzeuge",
    economy: "Kleinwagen",
    everyday: "Alltagsautos",
    sedans: "Limousinen",
    suv: "SUVs",
    luxury: "Luxusautos",
    sports: "Sportwagen",
    supercars: "Supercars",
  },
  fleet: {
    eyebrow: "Die Kollektion",
    title: "Unsere Flotte",
    sub: "Unsere aktuelle Kollektion – weitere Fahrzeuge folgen. Verfügbarkeit und Preise werden auf Anfrage bestätigt.",
    priceOnRequest: "Preis auf Anfrage",
    perDay: "/ Tag",
    seats: "Sitze",
    transmission: "Getriebe",
    viewDetails: "Details ansehen",
    enquire: "Jetzt anfragen",
    noDeposit: "Ohne Kaution möglich",
    onRequest: "Auf Anfrage",
    available: "Verfügbar",
    unavailable: "Nicht verfügbar",
    sort: "Sortieren",
    sortFeatured: "Empfohlen",
    sortName: "Name A–Z",
    sortPriceAsc: "Preis: aufsteigend",
    sortPriceDesc: "Preis: absteigend",
    noDepositOnly: "Ohne Kaution",
    showAll: "Alle Fahrzeuge anzeigen",
    noResults: "Keine Fahrzeuge für diesen Filter.",
    sampleNote: "Verfügbarkeit, Ausstattung und Endpreis werden vor der Buchung immer von unserem Team bestätigt.",
    loading: "Flotte wird geladen…",
    loadError: "Die Flotte konnte nicht geladen werden. Bitte erneut versuchen.",
    retry: "Erneut versuchen",
  },
  modal: {
    specs: "Technische Daten",
    engine: "Motor",
    acceleration: "0–100 km/h",
    perDay: "pro Tag",
    finalNote: "Endpreis und Verfügbarkeit werden auf Anfrage bestätigt.",
    noDepositYes: "Ohne Kaution möglich (Bedingungen gelten)",
    enquireVehicle: "Dieses Auto anfragen",
    whatsapp: "WhatsApp",
    close: "Schließen",
    drag: "Zum Drehen ziehen",
    gallery: "Galerie",
    view360: "360°-Ansicht",
    fullscreen: "Vollbild",
    exitFullscreen: "Vollbild beenden",
    availability: "Verfügbarkeit",
    previous: "Vorheriges Bild",
    next: "Nächstes Bild",
  },
  nodeposit: {
    eyebrow: "Flexible Miete",
    title: "MIETEN OHNE KAUTION MÖGLICH",
    text: "Genießen Sie ein flexibleres Mieterlebnis in Dubai. Die Kautionsfreiheit gilt für ausgewählte Fahrzeuge und unter bestimmten Bedingungen, z. B. Mietdauer und Fahrerprofil.",
    cta: "Fahrzeuge ohne Kaution entdecken",
    note: "Gilt nur für ausgewählte Fahrzeuge. Bedingungen werden bei der Anfrage bestätigt.",
  },
  how: {
    eyebrow: "Der Ablauf",
    title: "So funktioniert es",
    steps: [
      { t: "Wählen Sie Ihr Auto", d: "Entdecken Sie unsere Auswahl – vom Alltagsauto bis zu Luxusautos und Supercars." },
      { t: "Senden Sie Ihre Anfrage", d: "Teilen Sie uns Wunschfahrzeug und Mietzeitraum mit." },
      { t: "Buchung bestätigen", d: "Unser Team bestätigt Verfügbarkeit, Preis, Voraussetzungen und die nächsten Schritte." },
    ],
  },
  about: {
    eyebrow: "Über A&A MOTORS",
    title1: "MEHR ALS EIN AUTO.",
    title2: "ES IST IHR LIFESTYLE.",
    p1: "Bei A&A MOTORS glauben wir: Jede Fahrt verdient das richtige Auto.",
    p2: "Ob Sie Dubai erkunden, geschäftlich unterwegs sind, ein komfortables Alltagsauto suchen oder ein Performance-Fahrzeug erleben möchten – unsere Vision ist es, die Suche nach Ihrem nächsten Auto einfach und flexibel zu machen.",
    p3: "Von alltagstauglichen Klassikern bis zu außergewöhnlichen Fahrerlebnissen bauen wir eine Marke rund um Auswahl, Service und die Freiheit, so zu fahren, wie Sie es möchten.",
  },
  trust: {
    eyebrow: "Vertrauen & Transparenz",
    title: "Mit Vertrauen mieten",
    items: [
      { t: "Klare Mietbedingungen", d: "Alle Bedingungen erhalten Sie vor jeder Bestätigung schriftlich." },
      { t: "Transparente Preise", d: "Keine versteckten Kosten – der Endpreis wird bei der Anfrage bestätigt." },
      { t: "Fahrzeugabhängige Kaution", d: "Kaution oder Kautionsfreiheit hängen vom gewählten Fahrzeug ab." },
      { t: "Schneller Support", d: "Erreichen Sie uns direkt per WhatsApp oder Telefon – in Ihrer Sprache." },
      { t: "Unkomplizierte Anfragen", d: "Ein Formular oder eine Nachricht – unser Team kümmert sich um den Rest." },
    ],
  },
  faq: {
    eyebrow: "Gut zu wissen",
    title: "Häufige Fragen",
    items: [
      {
        q: "Welche Unterlagen brauche ich, um in Dubai ein Auto zu mieten?",
        a: "In der Regel: gültiger Führerschein, Reisepass oder Emirates ID sowie eine Zahlungskarte. Touristen benötigen je nach Heimatland zusätzlich einen internationalen Führerschein. Die genauen Anforderungen hängen vom Fahrzeug und Ihrem Aufenthaltsstatus ab – unser Team bestätigt alles vor der Buchung.",
      },
      {
        q: "Ist ein Reisepass erforderlich?",
        a: "Touristen legen in der Regel Reisepass mit Einreisestempel oder Visum vor; Einwohner der VAE nutzen die Emirates ID. Die Anforderungen variieren und werden für Ihre Buchung bestätigt.",
      },
      {
        q: "Ist ein gültiger Führerschein Pflicht?",
        a: "Ja, immer. Je nach Ausstellungsland kann ein internationaler Führerschein nötig sein. Für manche Hochleistungsfahrzeuge gelten Mindestalter oder Mindest-Führerscheindauer.",
      },
      {
        q: "Gibt es Mieten ohne Kaution?",
        a: "Ja, für ausgewählte Fahrzeuge und unter bestimmten Bedingungen. Die Möglichkeit hängt von Fahrzeug, Mietdauer und Fahrerprofil ab – fragen Sie einfach bei uns nach.",
      },
      {
        q: "Kann ich ein Auto nur für einen Tag mieten?",
        a: "Ja, Tagesmieten sind bei vielen Fahrzeugen möglich; bei einzelnen Modellen kann eine Mindestmietdauer gelten.",
      },
      {
        q: "Kann das Auto ins Hotel geliefert werden?",
        a: "Eine Lieferung innerhalb Dubais – zu Hotel, Adresse oder Flughafen – ist auf Anfrage möglich, abhängig von Fahrzeug und Planung.",
      },
      {
        q: "Wie prüfe ich die Verfügbarkeit eines Fahrzeugs?",
        a: "Senden Sie eine Anfrage über das Formular oder WhatsApp mit Ihren Wunschdaten. Unser Team bestätigt Verfügbarkeit und Endpreis vor jeder Buchung.",
      },
      {
        q: "Welche Miet- und Versicherungsbedingungen gelten?",
        a: "Eine Basisversicherung ist meist enthalten. Selbstbeteiligung, Kilometerlimit, Tank- und Salik-Regelungen (Maut) variieren je nach Fahrzeug. Alle Konditionen werden vor der Bestätigung transparent mitgeteilt.",
      },
    ],
  },
  form: {
    eyebrow: "Buchungsanfrage",
    title: "Buchung anfragen",
    sub: "Sagen Sie uns, was Sie fahren möchten und wann. Unser Team antwortet mit Verfügbarkeit, genauem Preis und Voraussetzungen.",
    name: "Vollständiger Name",
    email: "E-Mail-Adresse",
    phone: "Telefonnummer",
    method: "Bevorzugter Kontaktweg",
    methodWhatsapp: "WhatsApp",
    methodCall: "Telefonanruf",
    methodEmail: "E-Mail",
    vehicle: "Wunschfahrzeug",
    vehicleAny: "Egal / Beratung erwünscht",
    pickup: "Abholdatum",
    return: "Rückgabedatum",
    handover: "Abholung oder Lieferung",
    handoverPickup: "Ich hole das Auto ab",
    handoverDelivery: "Lieferung an mich (Hotel / Adresse / Flughafen)",
    message: "Zusätzliche Nachricht",
    messagePh: "Flugdaten, Lieferadresse, Fragen…",
    submit: "Buchung anfragen",
    sending: "Wird gesendet…",
    success: "Deine Anfrage ist fertig — WhatsApp hat sich mit allen Details geöffnet. Einfach auf Senden drücken, wir melden uns umgehend.",
    whatsappNote: "Beim Absenden öffnet sich WhatsApp mit deiner Anfrage — der schnellste Weg zu uns.",
    error: "Beim Senden ist ein Fehler aufgetreten. Bitte erneut versuchen oder per WhatsApp kontaktieren.",
    errRequired: "Dieses Feld ist erforderlich",
    errEmail: "Bitte eine gültige E-Mail-Adresse eingeben",
    errDates: "Das Rückgabedatum darf nicht vor dem Abholdatum liegen",
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Direkter Draht zu uns",
    text: "Der schnellste Weg zu Verfügbarkeit und Preisen. Wir antworten per WhatsApp und Telefon.",
    whatsapp: "WhatsApp schreiben",
    whatsappAlt: "WhatsApp — 2. Linie",
    callUs: "Anrufen",
    uae: "VAE",
    germany: "Deutschland",
    uaeNote: "Telefonate",
    germanyNote: "WhatsApp & Anrufe",
    copy: "Kopieren",
    copied: "Kopiert",
  },
  floating: {
    open: "Kontaktoptionen",
    whatsapp: "WhatsApp",
    whatsappAlt: "WhatsApp (2. Linie)",
    callUae: "VAE anrufen",
    callDe: "Deutschland anrufen",
  },
  footer: {
    desc: "Premium-Autovermietung in Dubai – vom Alltagsauto bis zum besonderen Erlebnis.",
    fleetTitle: "Flotte",
    contactTitle: "Kontakt",
    legalTitle: "Rechtliches",
    socialTitle: "Folgen Sie uns",
    privacy: "Datenschutz",
    terms: "AGB",
    cookies: "Cookie-Einstellungen",
    impressum: "Impressum",
    rights: "Alle Rechte vorbehalten.",
    socialPlaceholder: "Offizielle Profile folgen in Kürze",
  },
  cookies: {
    text: "Wir verwenden nur notwendigen Speicher für Ihre Spracheinstellung sowie Analyse zur Verbesserung der Website. Keine Werbe-Cookies.",
    accept: "Akzeptieren",
    decline: "Ablehnen",
  },
  legal: {
    privacyTitle: "Datenschutzerklärung",
    termsTitle: "Allgemeine Geschäftsbedingungen",
    impressumTitle: "Impressum",
    backHome: "Zurück zur Startseite",
    impressumNote: "Rechtliche Angaben zur Website von A&A MOTORS. Mit [wird ergänzt] markierte Felder werden vervollständigt, sobald die offiziellen Registrierungsunterlagen vorliegen.",
    impressumFields: [
      "Marke / Firmenname: A&A MOTORS",
      "Gründer / Gesetzliche Vertreter: Abadellh Aiouze · Amin Schmidt",
      "Standort: Dubai, Vereinigte Arabische Emirate — vollständige registrierte Anschrift: [wird ergänzt]",
      "Handelslizenznummer: [wird ergänzt]",
      "USt- / TRN-Nummer: [wird ergänzt]",
      "Verantwortlich für den Inhalt (§ 55 Abs. 2 RStV): Abadellh Aiouze · Amin Schmidt",
    ],
    privacySections: [
      { h: "Welche Daten wir erheben", p: "Bei einer Buchungsanfrage verarbeiten wir die von Ihnen angegebenen Daten – Name, E-Mail, Telefonnummer, Wunschfahrzeug und Mietzeitraum – ausschließlich zur Beantwortung Ihrer Anfrage." },
      { h: "Wie wir sie nutzen", p: "Ihre Daten werden nur zur Bearbeitung Ihrer Anfrage und ggf. zur Erstellung des Mietvertrags verwendet. Wir verkaufen Ihre Daten nicht und geben sie nicht zu Marketingzwecken weiter." },
      { h: "Speicherung & Löschung", p: "Anfragen werden sicher gespeichert und nur so lange aufbewahrt, wie es für Ihre Anfrage und gesetzliche Pflichten erforderlich ist." },
      { h: "Ihre Rechte", p: "Sie können jederzeit Auskunft, Berichtigung oder Löschung Ihrer personenbezogenen Daten verlangen – per WhatsApp oder Telefon." },
    ],
    termsSections: [
      { h: "Allgemeines", p: "Diese Bedingungen regeln die Nutzung der Website von A&A MOTORS. Fahrzeuge, Verfügbarkeiten und Preise sind Beispielinhalte, bis sie in einem individuellen Mietvertrag bestätigt werden." },
      { h: "Anfragen & Buchungen", p: "Eine Anfrage begründet keine Buchung. Ein Mietvertrag kommt erst zustande, nachdem unser Team Verfügbarkeit, Preis und Voraussetzungen mit Ihnen bestätigt hat." },
      { h: "Fahrzeuge & Preise", p: "Gezeigte Fahrzeuge, Ausstattungen und Preise sind unverbindlich. Endgültige Konditionen – inkl. Kaution, Versicherung, Kilometern und Salik-Maut – werden vor der Buchung mitgeteilt." },
      { h: "Haftung", p: "Wir bemühen uns um Genauigkeit, können aber nicht garantieren, dass alle Inhalte jederzeit vollständig und aktuell sind." },
    ],
  },
  admin: {
    login: "Admin-Login",
    email: "E-Mail",
    password: "Passwort",
    signIn: "Anmelden",
    signingIn: "Anmeldung…",
    loginError: "Ungültige Zugangsdaten oder zu viele Versuche.",
    dashboard: "Flotten-Dashboard",
    vehicles: "Fahrzeuge",
    enquiries: "Anfragen",
    logout: "Abmelden",
    addVehicle: "Fahrzeug hinzufügen",
    edit: "Bearbeiten",
    del: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    name: "Name",
    category: "Kategorie",
    price: "Preis / Tag (AED, leer = auf Anfrage)",
    seats: "Sitze",
    transmission: "Getriebe",
    availability: "Verfügbarkeit",
    noDeposit: "Ohne Kaution möglich",
    image: "Bild-URL",
    featured: "Empfohlen",
    status: "Status",
    empty: "Noch keine Anfragen.",
    confirmDelete: "Dieses Fahrzeug löschen?",
    dates: "Zeitraum",
    message: "Nachricht",
    back: "Zurück zur Website",
    vehicleSaved: "Fahrzeug gespeichert",
    vehicleDeleted: "Fahrzeug gelöscht",
    statusUpdated: "Status aktualisiert",
    newVehicle: "Neues Fahrzeug",
    editVehicle: "Fahrzeug bearbeiten",
  },
};
